import { createApp } from "vue";
import {store} from '@/store/index'
import { ElMessage } from 'element-plus'

const blacklist = ['website_shared_user']
const install = (app) => {
  app.directive('operation', {
    mounted(el, binding, vnode)
    {
      el.addEventListener('click', (event) => {
        const name = store.getters?.userInfo?.userName
        if (blacklist.includes(name)) {
          // el.parentNode && el.parentNode.removeChild(el)
          // 阻止事件冒泡和默认行为
          event.stopImmediatePropagation()
          event.preventDefault()
          
          ElMessage.warning('演示账号，无权操作此功能')
          }
      }, true) // 使用捕获阶段，确保在业务逻辑之前触发
    }
  })
  app.directive("hasPermi", {
    mounted(el, binding, vnode) {
      const { value } = binding
      const all_permission = "*:*:*";
      const permissions = store.getters && store.getters.permissions

      // 过滤出路由的权限
      let isAdmin =
        (permissions?.length && permissions?.includes("*:*:*")) ||
        permissions?.includes("adminFlag") ||
        store.getters.userInfo?.admin;
      // 如果是超管，直接跳出
      if (isAdmin) {
        return true;
      }

      if (value && value instanceof Array && value.length > 0) {
        const permissionFlag = value


        const hasPermissions = permissions && permissions.some(permission => {
          
          return all_permission === permission || permissionFlag.includes(permission) || permissionFlag.includes('*')
        })

        if (!hasPermissions) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        throw new Error(`请设置操作权限标签值`)
      }
    }
  });
  
};

export function isCanOperation() {
  const name = store.getters?.userInfo?.userName
  return !blacklist.includes(name)
}

export default {
  install,
};
